import React from "react";

export function ResearchInfo() {
  return (
    <div className="mt-4 bg-blue-50 p-4 rounded-xl border border-blue-100 flex items-start">
      <div className="flex-shrink-0 mr-3">
        <svg
          className="w-6 h-6 text-blue-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <div>
        <p className="text-sm font-semibold text-gray-700">
          People using Calorie Counter for 3 months lose twice as much weight as
          for 1 month
        </p>
        <p className="text-xs text-gray-500 mt-1">
          *According to Calorie Counter user research, 2024
        </p>
      </div>
    </div>
  );
}
